<template>
  <div ref="list" class="version-button-container button-container" :flex="flexStr">
    <div ref="listItems" v-for="(item,index) in items" class="version-button" :class="{'version-button-noactive':selectId!=index,'version-button-active':selectId==index,'line-undisplay':item.name1.indexOf('<br>')!=-1}"
         @click="onClick(item,index)" :style="{width:itemWidth==null?'auto':itemWidth+'px',marginLeft:autoPadding=='auto'?'0.6%':''}" flex="cross:center main:center">
      <div ref="items" v-html="GLOBAL_VARS.terminal==='chebaba'? item.cbbname1: item.name1" flex="dir:top" style="position:relative">

      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
  export default {
    name: "VersionList",
    data() {
      return {
        selectId: 0,
        itemWidth: null,
        GLOBAL_VARS,
        flexStr:'cross:center'
      }
    },
    methods: {
      onClick(item, index) {
        this.selectId = index;
        Vue.prototype.cbbCarTypeId=item.cbbCarTypeId;
        this.$emit('select', item);
      },
      getSelectItem(){
        return this.$refs.listItems[this.selectId];
      },
      resize() {
        var maxWidth = -1;
        for (var i = 0; i < this.$refs.items.length; i++) {
          if (maxWidth == -1) {
            maxWidth = $(this.$refs.items[i]).width();
          } else if (maxWidth < $(this.$refs.items[i]).width()) {
            maxWidth = $(this.$refs.items[i]).width();
          }
        }
        this.itemWidth = maxWidth + 30;
        if(this.autoPadding){
          setTimeout(()=>{
            if(this.$refs.list.parentElement){
              var w = document.body.clientWidth - this.$refs.list.parentElement.getBoundingClientRect().left-10;
              $(this.$refs.list).width(w+'px');
              this.flexStr = 'cross:center box:mean';
            }
            },300);
        }
        else{
          this.flexStr = 'cross:center';
          window.requestAnimationFrame(this.resize)
        }
      }
    },
    props: {
      items: {
        default: () => [],
        type: Array
      },
      autoPadding:{
        default:null,
        type:String
      }
    },
    watch:{
      items:{
        handler(newVal) {
          this.resize();
        },
        deep: true
      }
    },
    mounted() {
      this.resize();
      window.addEventListener("resize",this.resize);
      Vue.prototype.cbbCarTypeId = getConfigure('carVersion').items[0].cbbCarTypeId;

    }
  }
</script>

<style lang="scss">

</style>
